// Файл session_recovery.js

/**
 * Модуль обслуживает сценарий `session_recovery` в разделе `utils`.
 * Он содержит обработчики и данные, относящиеся к этой части клиентского
 * интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

import { session_storage } from './session_storage';



import { log_frontend_error } from './frontend_logger';



const ACCESS_CACHE_KEY = 'potale_access_rights';
const AUTH_CACHE_KEY = 'potale_auth_verified_at';
let redirect_started = false;

const clear_session_cache = () => {
    try {
        session_storage.remove_item(ACCESS_CACHE_KEY);
        session_storage.remove_item(AUTH_CACHE_KEY);
    } catch (error) {
        // sessionStorage может быть недоступен в приватном режиме.
    }
};

const should_redirect = (error) => {
    if (
        typeof window === 'undefined'
        || error?.response?.status !== 401
    ) {
        return false;
    }

    const path = window.location.pathname || '/';
    return path !== '/' && !path.startsWith('/page_load_mobile_version');
};

export const handle_session_error = (error) => {
    if (!should_redirect(error)) {
        return;
    }

    clear_session_cache();
    window.dispatchEvent(new CustomEvent('potale:session-expired'));

    if (redirect_started) {
        return;
    }

    redirect_started = true;
    window.location.replace('/');
};

const report_api_error = (error) => {
    const status = Number(error?.response?.status || 0);
    const request_path = String(error?.config?.url || '');

    const request_code = String(error?.code || '');
    const is_driver_poll = request_path.includes('/api/get_driver_messages');
    const is_expected_poll_end = is_driver_poll && [
        'ECONNABORTED',
        'ERR_CANCELED',
    ].includes(request_code);

    if (
        request_path.includes('/api/frontend_log')
        || is_expected_poll_end
        || (status > 0 && status < 500)
    ) {
        return;
    }

    log_frontend_error('api_error', error, {
        http_status: status,
        request_method: String(error?.config?.method || '').toUpperCase(),
        request_path,
    });
};


export const process_api_error = async (error, csrf_retry) => {
    try {
        return await csrf_retry(error);
    } catch (final_error) {
        report_api_error(final_error);
        handle_session_error(final_error);
        throw final_error;
    }
};
